import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DtrService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }


  /**
   * Get absent employees with pagination support.
   */
  getAbsentEmployeesByDatePaginated(date: string, perPage: number, page: number): Observable<any> {
    let params = new HttpParams().set('date', date).set('per_page', perPage).set('page', page);
    return this.http.get(`${this.apiUrl}/api/check-absent-employees`, { params });
  }


  /**
   * Get employees with dtr_required=true who did not log in for a given date.
   * @param date string (YYYY-MM-DD)
   */
  getAbsentEmployeesByDate(date: string): Observable<any> {
    const params = new HttpParams().set('date', date);
    return this.http.get(`${this.apiUrl}/api/check-absent-employees`, { params });
  }

  getOnlineEmployeesByDate(date: string, perPage: number, page: number): Observable<any> {
    let params = new HttpParams().set('date', date).set('per_page', perPage).set('page', page);
    return this.http.get(`${this.apiUrl}/api/online_employees`, { params });
  }

  /**
   * Get timesheet for an employee by employee_id and email_address,
   * filtered by year, month (number), and period (1-15 or 16-End).
   *
   * @param employee_id number
   * @param email string
   * @param year number
   * @param month number
   * @param period string ('1-15' or '16-End')
   */
  getEmployeeTimesheet(employee_id: number, email: string, year: number, month: number, period: string): Observable<any> {
    const params = new HttpParams()
      .set('employee_id', employee_id)
      .set('email', email)
      .set('year', year)
      .set('month', month)
      .set('period', period);
    return this.http.get(`${this.apiUrl}/api/employee-timesheet`, { params });
  }

  /**
   * Get all employee IDs, email addresses, and total hours for a given year, month, and period.
   * Optionally filter by employee_id and email_address.
   * @param year number
   * @param month number
   * @param period string ('1 - 15' or '16 - End')
   * @param employee_id number | undefined
   * @param email_address string | undefined
   */
  getAllEmployeeTimeSheets(year: number, month: number, period: string, employee_id?: number, email_address?: string): Observable<any> {
    let params = new HttpParams()
      .set('year', year)
      .set('month', month)
      .set('period', period);
    if (employee_id) {
      params = params.set('employee_id', employee_id);
    }
    if (email_address) {
      params = params.set('email_address', email_address);
    }
    return this.http.get(`${this.apiUrl}/api/employee-timesheets`, { params });
  }
}
